/**
 * Mock lookup data for Phase E development (`/dev/editor-sections`).
 * Real lookups come from the generated client (categories/products/customers/
 * manufacturers/customer-categories) in Phase I — these stand in so the
 * demo fixture's selected ids resolve to readable labels during section build.
 * (Sites already load from the v1 Sites controller — see use-sites-admin.)
 */

export interface LookupOption {
	id: number;
	label: string;
	/** Optional code/email shown muted in the option row. */
	sublabel?: string;
}

export const MOCK_CATEGORIES: LookupOption[] = [
	{ id: 1234, label: 'Σχολικά Βοηθήματα', sublabel: '1234' },
	{ id: 1318, label: '1ης Ηλικίας', sublabel: '1318' },
	{ id: 1319, label: '2ης Ηλικίας', sublabel: '1319' },
	{ id: 1320, label: 'Παιδικά Βιβλία', sublabel: '1320' },
	{ id: 1322, label: 'Λογοτεχνία', sublabel: '1322' }
];

export const MOCK_MANUFACTURERS: LookupOption[] = [
	{ id: 10, label: 'Εκδόσεις Πατάκη' },
	{ id: 11, label: 'Εκδόσεις Κέδρος' },
	{ id: 12, label: 'Εκδόσεις Μεταίχμιο' }
];

export const MOCK_CUSTOMER_CATEGORIES: LookupOption[] = [
	{ id: 1, label: 'Εγγεγραμμένοι' },
	{ id: 2, label: 'VIP' },
	{ id: 3, label: 'B2B' },
	{ id: 4, label: 'Πρώτη αγορά' },
	{ id: 5, label: 'Συνεργάτες Vodafone' }
];

export const MOCK_CUSTOMERS: LookupOption[] = [
	{ id: 101, label: 'Μαρία Παπαδοπούλου', sublabel: 'maria@example.gr' },
	{ id: 102, label: 'Γιώργος Ιωάννου', sublabel: 'giorgos@example.gr' }
];

export const MOCK_PRODUCTS: LookupOption[] = Array.from({ length: 60 }, (_, i) => ({
	id: 1000 + i,
	label: `Προϊόν ${i + 1}`,
	sublabel: `SKU-${1000 + i}`
}));

export async function loadMockProducts(query: string): Promise<LookupOption[]> {
	const q = query.toLowerCase();
	return MOCK_PRODUCTS.filter(p => p.label.toLowerCase().includes(q) || p.sublabel?.toLowerCase().includes(q)).slice(0, 20);
}
